import { gql, useQuery } from "@apollo/client";
import { createContext, FC, useCallback, useContext, useReducer } from "react";
import { Distributor } from "../api/schema";

const distributors_query = gql`
  query Distributors {
    distributors {
      id
      name
      search_url
      short_name
      updated_at
      created_at
    }
  }
`;

interface DistributorsQueryReponse {
  distributors: Distributor[];
}

export const DistributorRepositoryContext = createContext<Distributor[]>([]);

const RefetchRepositoryContext = createContext<() => void>(() => {});

export const DistributorRepositoryProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer(
    (__: Distributor[], new_value: Distributor[]) => new_value,
    []
  );

  const { refetch } = useQuery<DistributorsQueryReponse>(distributors_query, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if (data.distributors) dispatch(data.distributors);
    },
    onError: (error) => {
      console.log("got user list error", error);
    },
  });

  const fetch_new_data = useCallback(() => {
    console.log("refetching...");
    refetch().then((v) => {
      if (v.error) {
        console.error(v.error);
      } else if (v.loading) {
        console.log("loading...");
      } else if (v.data) {
        console.log("setting new data");
        dispatch(v.data.distributors);
      }
    });
  }, [dispatch, refetch]);

  return (
    <DistributorRepositoryContext.Provider value={state}>
      <RefetchRepositoryContext.Provider value={fetch_new_data}>
        {children}
      </RefetchRepositoryContext.Provider>
    </DistributorRepositoryContext.Provider>
  );
};

export const useDistributors = () => ({
  distributors: useContext(DistributorRepositoryContext),
  fetch_distributors: useContext(RefetchRepositoryContext),
});
